import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Authorizations } from '../interfaces';
import { CartService } from './cart.service';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  constructor(
    public cartService: CartService,
    public apiService: ApiService,
    public authService: AuthService
  ) {
  }

  authorization(body): Observable<any> {
    return this.apiService.post(`${this.apiService.loginAuthorize}`, body)
      .pipe(map(item => item));
  }

  editStock(body): Observable<any> {
    return this.apiService.post(`${this.apiService.loginAuthorizeStock}consume`, body)
      .pipe(map(item => item));
  }

  generateCode(): Observable<any> {
    return this.apiService.get(`${this.apiService.loginAuthorizeStock}generate`)
      .pipe(map(item => item));
  }

  authorizes(...arg): void {
    const user = this.authService.getUser().username;
    let autorize: Authorizations[] = this.cartService.getAutorizathion(user);
    if (autorize.length) {
      const exist = autorize.find(item => item.authorizationType === arg[0]);
      if (exist) {
        autorize = autorize.map(item => {
          if (item.authorizationType === arg[0]) {
            item = {
              authorizationType: arg[0],
              username: arg[1],
              previous: arg[2],
              current: arg[3]
            };
          }
          return item;
        });
      } else {
        if (arg[0] === 'FREIGHT_MODIFY' || arg[0] === 'FREIGHT_DELETE') {
          const FREIGHT = autorize.
            find(item => item.authorizationType === 'FREIGHT_MODIFY' || item.authorizationType === 'FREIGHT_DELETE');
          autorize = autorize
            .map(elem => (FREIGHT && FREIGHT.authorizationType === elem.authorizationType) ? undefined : elem)
            .filter(item => item);
        }
        autorize.push({
          authorizationType: arg[0],
          username: arg[1],
          previous: arg[2],
          current: arg[3]
        });
      }
    } else {
      autorize.push({
        authorizationType: arg[0],
        username: arg[1],
        previous: arg[2],
        current: arg[3]
      });
    }

    this.cartService.setAutorizathion(user, autorize);
  }

  deleteAuthorization(type: string) {
    const user = this.authService.getUser().username;
    let autorize: Authorizations[] = this.cartService.getAutorizathion(user);
    autorize = autorize.map((item: any) => {
      if (item.authorizationType !== type) {
        return item;
      }
    }).filter(item => item);
    this.cartService.setAutorizathion(user, autorize);
  }
}
